var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88366 1.84085H14.3694C14.6456 1.84085 14.8688 2.06401 14.8688 2.34023V13.826C14.8688 14.1022 14.6456 14.3253 14.3694 14.3253H8.75137C8.68271 14.3253 8.62653 14.2692 8.62653 14.2005V13.3266C8.62653 13.2579 8.68271 13.2017 8.75137 13.2017H13.7452V2.96445H3.50789V7.95825C3.50789 8.02692 3.45171 8.0831 3.38304 8.0831H2.50913C2.44046 8.0831 2.38428 8.02692 2.38428 7.95825V2.34023C2.38428 2.06401 2.60744 1.84085 2.88366 1.84085ZM6.42146 9.44703L5.60684 8.63241C5.59034 8.61583 5.57883 8.59495 5.5736 8.57214C5.56838 8.54934 5.56966 8.52553 5.57731 8.50341C5.58495 8.4813 5.59864 8.46178 5.61683 8.44706C5.63502 8.43235 5.65697 8.42303 5.68019 8.42018L8.47984 8.09246C8.55942 8.0831 8.62809 8.1502 8.61873 8.23135L8.29101 11.031C8.27852 11.134 8.15212 11.1777 8.07877 11.1043L7.26104 10.2866L3.26288 14.2848C3.2145 14.3331 3.13491 14.3331 3.08654 14.2848L2.42486 13.6231C2.37648 13.5747 2.37648 13.4951 2.42486 13.4467L6.42146 9.44703Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn);
export default __webpack_public_path__ + "static/media/btn.7586b01c356311ae1966105e1b1c84c4.svg";
export { ForwardRef as ReactComponent };